import type { StyleObject } from "../../theme/styled";
import { calcRemFromPx } from "../../theme/util";

type TypeProps = Pick<
  StyleObject,
  "fontWeight" | "fontSize" | "lineHeight" | "textTransform" | "letterSpacing"
>;

export type Components =
  | "DisplayL"
  | "DisplayM"
  | "HeadingL"
  | "HeadingM"
  | "HeadingS"
  | "HeadingXS"
  | "BodyM"
  | "BodyS"
  | "TitleM"
  | "TitleS"
  | "Caption"
  | "Overline";

export const font: Record<Components, TypeProps> = {
  DisplayL: {
    fontWeight: 700,
    fontSize: `${calcRemFromPx(40)}rem`,
    lineHeight: `${calcRemFromPx(44)}rem`,
  },
  DisplayM: {
    fontWeight: 700,
    fontSize: `${calcRemFromPx(32)}rem`,
    lineHeight: `${calcRemFromPx(36)}rem`,
  },
  HeadingL: {
    fontWeight: 700,
    fontSize: `${calcRemFromPx(24)}rem`,
    lineHeight: `${calcRemFromPx(30)}rem`,
  },
  HeadingM: {
    fontWeight: 700,
    fontSize: `${calcRemFromPx(20)}rem`,
    lineHeight: `${calcRemFromPx(26)}rem`,
  },
  HeadingS: {
    fontWeight: 600,
    fontSize: `${calcRemFromPx(17)}rem`,
    lineHeight: `${calcRemFromPx(22)}rem`,
  },
  HeadingXS: {
    fontWeight: 600,
    fontSize: `${calcRemFromPx(15)}rem`,
    lineHeight: `${calcRemFromPx(20)}rem`,
  },
  BodyM: {
    fontWeight: 400,
    fontSize: `${calcRemFromPx(17)}rem`,
    lineHeight: `${calcRemFromPx(24)}rem`,
  },
  BodyS: {
    fontWeight: 400,
    fontSize: `${calcRemFromPx(15)}rem`,
    lineHeight: `${calcRemFromPx(21)}rem`,
  },
  TitleM: {
    fontWeight: 500,
    fontSize: `${calcRemFromPx(17)}rem`,
    lineHeight: `${calcRemFromPx(22)}rem`,
  },
  TitleS: {
    fontWeight: 500,
    fontSize: `${calcRemFromPx(15)}rem`,
    lineHeight: `${calcRemFromPx(20)}rem`,
  },
  Caption: {
    fontWeight: 400,
    fontSize: `${calcRemFromPx(13)}rem`,
    lineHeight: `${calcRemFromPx(16)}rem`,
  },
  Overline: {
    fontWeight: 600,
    fontSize: `${calcRemFromPx(13)}rem`,
    lineHeight: `${calcRemFromPx(14)}rem`,
    textTransform: "uppercase",
  },
};
